import { Box, Stack, Button, Tooltip, Typography, FormControlLabel, Checkbox, TextField, Autocomplete } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'

const fieldLimits = {
    wardName: 50,
    RoomNo: 50,
}

export default function NurseStationConfig(props) {
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isDelete, setisDelete] = useState(false);
    const [deletedID, setdeletedID] = useState(null);
    const [isloader, setisloader] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [EditID, setEditID] = useState(null);
    const [formState, setFormState] = useState({
        // nurseCode: '',
        nurseName: '',
        wardName: null,
        RoomNo: null,
    });
    const [EditPopup, setEditPopup] = useState(false);
    const [ListState, setListState] = useState({
        WardList: [],
        RoomList: [],
        FilteredRoomList: [],
        NurseRoomList: [],
        NurseList: []
    });
    let commonDisable = props?.Access?.editAccess

    useEffect(() => {
        fetchAndSetList('WardList', Serviceurls.WARD_CONFIG);
        fetchAndSetList('RoomList', Serviceurls.BED_CONFIG);
        fetchAndSetList('NurseRoomList', Serviceurls.MRD_NURSE_STATION_GET_POST);
        fetchAndSetList('NurseList', Serviceurls.FO_STAFF_LIST);
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const fetchAndSetList = async (stateKey, url) => {
        try {
            setisloader(true);
            const response = await RestAPIService.getAll(url);
            if (response?.data?.status === 'success') {
                const listData = response?.data?.data || [];
                setListState((prev) => ({
                    ...prev,
                    [stateKey]: listData
                }));
            }
        } catch (e) {
            const msg = e?.response?.data?.status === 'fail' ? e.response.data.message : e.message;
            errorMessage(msg);
        } finally {
            setisloader(false);
        }
    };

    const AddNurseRoomMaster = () => {
        try {
            if (!formState?.nurseName || CommonValidation.removeSpace(formState?.nurseName) == "") {
                return errorMessage('Please Select Nurse');
            }
            let data = {
                // nurse_station_name: ((formState?.nurseName ?? '').trim()),
                ward_id: formState?.wardName?.id || null,
                floor_id: formState?.RoomNo?.id || null,
                nurse_profile_id: formState?.nurseName?.staff_id,
                is_active: isActive,
                ...(EditID && { id: EditID })
            }
            let RestAPI = EditID ? RestAPIService.updateWithOutId(data, Serviceurls.MRD_NURSE_STATION_GET_POST) : RestAPIService.create(data, Serviceurls.MRD_NURSE_STATION_GET_POST)
            setisloader(true)
            RestAPI.then((response) => {
                if (response.data.status === 'success') {
                    setFormState({
                        // nurseCode: '',
                        nurseName: '',
                        wardName: null,
                        RoomNo: null,
                    });
                    setIsActive(true)
                    setEditID(null)
                    fetchAndSetList('NurseRoomList', Serviceurls.MRD_NURSE_STATION_GET_POST);
                    setisloader(false)
                    setEditPopup(false)
                }
            }).catch(e => {
                setisloader(false)
                if (e?.response?.data?.status === 'fail') {
                    errorMessage(e.response.data.message)
                } else {
                    errorMessage(e.message)
                }
            })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const tableView = () => {

        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
                </Box>

            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = ListState?.NurseRoomList?.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        ListState?.NurseRoomList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            // {
            //     field: 'nurse_station_code', headerName: 'Nurse Station Code', flex: 0.4,
            //     renderCell: (params) => (<Box component={'div'}>{params?.row?.nurse_station_code ? params?.row?.nurse_station_code : '-'}</Box>)
            // },
            {
                field: 'ward_name', headerName: 'Ward', flex: 0.4,
                renderCell: (params) => (params.row.ward_name ? params.row.ward_name?.length > 70 ?
                    <Tooltip placement="top" title={params.row.ward_name}><Typography fontSize={'0.9vw'}>{params.row.ward_name?.slice(0, 68) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.ward_name}</Typography> : '-')
            },
            {
                field: 'floor_name', headerName: 'Room', flex: 0.4,
                renderCell: (params) => (params.row.floor_name ? params.row.floor_name?.length > 70 ?
                    <Tooltip placement="top" title={params.row.floor_name}><Typography fontSize={'0.9vw'}>{params.row.floor_name?.slice(0, 68) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.floor_name}</Typography> : '-')
            },
            {
                field: 'nurse_station_name', headerName: 'Nurse', flex: 0.4,
                renderCell: (params) => (params.row.nurse_station_name ? params.row.nurse_station_name?.length > 70 ?
                    <Tooltip placement="top" title={params.row.nurse_station_name}><Typography fontSize={'0.9vw'}>{params.row.nurse_station_name?.slice(0, 68) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.nurse_station_name}</Typography> : '-')
            },
            ...(commonDisable ? [{
                field: 'action', headerName: 'Action', flex: 0.2, headerAlign: "center", align: "center",
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw" onClick={() => {
                                let FilteredRoom = ListState?.RoomList?.filter((item) => item?.ward_id === params.row.ward_id);
                                setFormState({
                                    // nurseCode: params.row.nurse_station_code || '',
                                    nurseName: params.row.nurse_profile_id ? ListState?.NurseList?.find((item) => item.staff_id == params.row.nurse_profile_id) : null,
                                    wardName: params.row.ward_id ? ListState?.WardList?.find((item) => item.id == params.row.ward_id) : null,
                                    RoomNo: params.row.floor_id ? FilteredRoom?.find((item) => item.id == params.row.floor_id) : null
                                });
                                setListState({
                                    ...ListState,
                                    FilteredRoomList: FilteredRoom
                                });
                                setEditID(params.row.id);
                                setIsActive(params.row.is_active || false);
                            }} />
                        </Stack>
                    </Stack>)

            }] : [])
        ]
        return (
            <Box sx={{ height: '64vh' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={ListState?.NurseRoomList || []}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    pageSizeOptions={[10, 20, 30]}
                    pagination
                    paginationMode="client"
                    paginationModel={{
                        page: page,
                        pageSize: pageSize
                    }}
                    onPaginationModelChange={(model) => {
                        setpage(model.page)
                        setpageSize(model.pageSize)
                    }}
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    headerHeight={40}
                    density='compact'
                    disableRowSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const PopupClose = () => {
        setisDelete(false);
        setdeletedID(null);
        setEditPopup(false)
    }

    const deleteNurseRoomMaster = () => {
        try {
            let ID = deletedID ? [deletedID] : (delIDs || [])
            RestAPIService.delete(Serviceurls.MRD_NURSE_STATION_GET_POST + `?id=${ID}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        fetchAndSetList('NurseRoomList', Serviceurls.MRD_NURSE_STATION_GET_POST);
                        setdelIDs([]);
                        setCheckBoxList([]);
                        setdeletedID(null);
                        setisDelete(false)
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const textBox = (label, name, val, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    autoComplete='off'
                    value={val || ''}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => {
                        const { value } = e.target;
                        if (value === "" || value.length <= (fieldLimits[name] || 50)) {
                            setFormState({
                                ...formState,
                                [name]: e.target.value
                            });
                        }
                    }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const autoComplete = (label, name, optionName, Options, width) => {
        return (
            <Autocomplete
                size='small'
                options={Options}
                disabled={(name === 'RoomNo' && !formState?.wardName)}
                getOptionLabel={(option) => option?.[optionName]?.toString?.() ?? ""}
                value={formState?.[name] || null}
                onChange={(event, newValue) => {
                    if (name === "wardName") {
                        var FilteredRoomList = [];
                        FilteredRoomList = ListState?.RoomList?.filter((item) => item?.ward_id === newValue?.id);
                        if (newValue) {
                            setListState({
                                ...ListState,
                                FilteredRoomList: FilteredRoomList
                            });
                            setFormState({
                                ...formState,
                                wardName: newValue,
                                RoomNo: null
                            })
                        } else {
                            setListState({
                                ...ListState,
                                FilteredRoomList: []
                            });
                            setFormState({
                                ...formState,
                                wardName: null,
                                RoomNo: null
                            })
                        }
                    } else {
                        setFormState({
                            ...formState,
                            [name]: newValue
                        })
                    }
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        sx={{ width: width, marginRight: '0.3vw' }}
                    />
                )}
            />
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '13vh', width: '93vw', alignContent: 'center', backgroundColor: "white", padding: "0.5vw" }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row' }}>
                    {/* {textBox("MRD Nurse Code", 'nurseCode', formState?.nurseCode, '15vw', true)} */}
                    {/* {textBox("MRD Nurse Name*", 'nurseName', formState?.nurseName, '15vw', false)} */}
                    {autoComplete("Select Ward *", 'wardName', 'ward_name', ListState?.WardList, '14vw')}
                    {autoComplete("Select Room *", 'RoomNo', 'room_number', ListState?.FilteredRoomList, '14vw')}
                    {autoComplete("Select Nurse *", 'nurseName', 'nurse', ListState?.NurseList, '14vw')}
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "0.5vw" }}>
                    <Box sx={{ display: 'flex' }}>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} disabled={!EditID} size='small' />} label={"Active"} />
                    </Box>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw', marginRight: "0.5vw" }}
                            disabled={!commonDisable}
                            onClick={() => {
                                setFormState({
                                    // nurseCode: '',
                                    nurseName: '',
                                    wardName: null,
                                    RoomNo: null,
                                });
                                setIsActive(true)
                                setEditID(null)
                            }}>Clear</Button>
                        <Button size='small' variant='contained' disabled={!commonDisable} sx={{ textTransform: 'capitalize', width: '7vw' }}
                            onClick={() => { EditID && !isActive ? setEditPopup(true) : AddNurseRoomMaster() }}>{EditID ? 'Update' : 'Save'}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '64vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {EditPopup ?
                <DeletePopup
                    DeletTitle={`This action will affect in nurse station mapping as well, Are you sure you want to In-Active this item ?`}
                    deleteAlertPopupClose={PopupClose.bind(this)}
                    removeData={AddNurseRoomMaster.bind(this)}
                    ButtonText={'Yes'}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`This action will affect in nurse station mapping as well, Are you sure you want to delete this item ?`}
                    DeleteNotify={"This action cannot be undone."}
                    deleteAlertPopupClose={PopupClose.bind(this)}
                    removeData={deleteNurseRoomMaster.bind(this)}
                    ButtonText={'Yes'}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}